import { render, staticRenderFns } from "./FonteEsusPecGlobal.vue?vue&type=template&id=7f9b05cd"
import script from "./FonteEsusPecGlobal.vue?vue&type=script&lang=js"
export * from "./FonteEsusPecGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports